import { DataInstance, ISOTimestamp } from "@busy-human/gearbox";
import { Events, ManagementCalendars, Userspaces } from "@busy-human/k9-library";
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import { Agreement, type AgreementRequirement } from '@busy-human/contract-module';

export const unlinkGoogle = httpsCallable<void | { uid?: string }, any>(functions, 'unlinkGoogle');
export const getAdminCalendars = httpsCallable<void, ManagementCalendars.Model[]>(functions, 'getAdminCalendars');
export const createCalendar = httpsCallable<{name: string}, ManagementCalendars.Model>(functions, "createCalendar");
export const getCalendarColors = httpsCallable<void, any>(functions, "getCalendarColors");

interface EventAddData {
    calendarId: string
    event: Events.Model
}
export const addCalendarEvent = httpsCallable<EventAddData, string>(functions, "addCalendarEvent");

export interface ListFilterOptions {
    dogId?: string
    userId?: string
    trainerId?: string
    startTime?: ISOTimestamp
    endTime?: ISOTimestamp
}
export const queryCalendar = httpsCallable<ListFilterOptions, DataInstance<Events.Model>[]>(functions, 'queryCalendar');
export const adminQueryCalendar = httpsCallable<ListFilterOptions, Record<string, DataInstance<Events.Model>[]>>(functions, 'adminQueryCalendar');
export const testAddCustomer = httpsCallable<{uid: string}, string>(functions, 'testAddCustomer');

interface InvoiceAddData {
    event: DataInstance<Events.Model>
    agreementId?: string,
    weeks?: number
    dueAt?: ISOTimestamp
    price?: number,
    discountPercent?: number,
    description?: string,
    queueAt?: ISOTimestamp,
    partialPayments?: boolean
}
export const generateEventInvoice = httpsCallable<InvoiceAddData, string>(functions, 'generateEventInvoice');
export const sendInvoiceEmail = httpsCallable<{invoiceId: string}, string>(functions, 'sendInvoiceEmail');

export const beginQuickbooksAuth = httpsCallable<void, string>(functions, 'beginQuickbooksAuth');
export const checkQuickbooksAuth = httpsCallable<void, boolean>(functions, "checkQuickbooksAuth");

export const checkAgreementRequirements = httpsCallable<AgreementRequirement.checkAgreementRequirementOptions, AgreementRequirement.checkAgreementRequirementResult>(functions, 'checkAgreementRequirement');

interface getAgreementsData {
    agreementName: string,
    userId?: string,
}
export const getAgreements = httpsCallable<getAgreementsData, {agreements: DataInstance<Agreement.Model<any, any>>[]}>(functions, 'getAgreements');

export const createNewUser = httpsCallable<{user: Userspaces.Model}, void>(functions, 'createNewUser');

export const getAgreementUrl = httpsCallable<{agreementId: string, isSender?: boolean}, {url: string}>(functions, 'getAgreementUrl');

export const stripeIssueRefund = httpsCallable<{transactionId: string}, void>(functions, "stripeIssueRefund");

interface adminCheckEmailData {
    email: string
}
type adminCheckEmailResponse = {
    exists: false,
    email?: never,
    uid?: never
} | {
    exists: true,
    email: string,
    uid: string
}

export const adminCheckEmail = httpsCallable<adminCheckEmailData, adminCheckEmailResponse>(functions, "adminCheckEmail");